import { render, staticRenderFns } from "./ArticleVariationSlide.vue?vue&type=template&id=6fb3140d&scoped=true&"
import script from "./ArticleVariationSlide.vue?vue&type=script&lang=js&"
export * from "./ArticleVariationSlide.vue?vue&type=script&lang=js&"
import style0 from "./ArticleVariationSlide.vue?vue&type=style&index=0&id=6fb3140d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb3140d",
  null
  
)

export default component.exports